<template>
  <section id="focus-areas" class="o-section c-focus-section" v-my-section-class>

    <!-- Background -->
    <div class="o-background" v-if="$store.state.device !== 0">
      <div class="o-background__inner">
        <transition name="quick-fade">
          <div class="o-background__group o-background__group--purple" key="purple" v-if="tabIndex === 0">
            <my-circle class="o-background__item o-background__item--1" :image-file="'circles/focus/safety-1'" :variant="2"></my-circle>
            <my-circle class="o-background__item o-background__item--2" :image-file="'circles/focus/safety-2'"></my-circle>
          </div>
          <div class="o-background__group o-background__group--turq" key="turq" v-if="tabIndex === 1">
            <my-circle class="o-background__item o-background__item--1" :image-file="'circles/focus/network-reliability-1'" :variant="2"></my-circle>
            <my-circle class="o-background__item o-background__item--2" :image-file="'circles/focus/network-reliability-2'"></my-circle>
          </div>
          <div class="o-background__group o-background__group--red" key="red" v-if="tabIndex === 2">
            <my-circle class="o-background__item o-background__item--1" :image-file="'circles/focus/customer-satisfaction-1'" :variant="2"></my-circle>
            <my-circle class="o-background__item o-background__item--2" :image-file="'circles/focus/customer-satisfaction-2'"></my-circle>
          </div>
          <div class="o-background__group o-background__group--smoke" key="smoke" v-if="tabIndex === 3">
            <my-circle class="o-background__item o-background__item--1" :image-file="'circles/focus/value-for-money-1'" :variant="2"></my-circle>
            <my-circle class="o-background__item o-background__item--2" :image-file="'circles/focus/value-for-money-2'"></my-circle>
          </div>
          <div class="o-background__group o-background__group--orange" key="orange" v-if="tabIndex === 4">
            <my-circle class="o-background__item o-background__item--1" :image-file="'circles/focus/communities-environment-1'" :variant="2"></my-circle>
            <my-circle class="o-background__item o-background__item--2" :image-file="'circles/focus/communities-environment-2'"></my-circle>
          </div>
          <div class="o-background__group o-background__group--blue" key="blue" v-if="tabIndex === 5">
            <my-circle class="o-background__item o-background__item--1" :image-file="'circles/focus/stakeholder-engagement-1'" :variant="2"></my-circle>
            <my-circle class="o-background__item o-background__item--2" :image-file="'circles/focus/stakeholder-engagement-2'"></my-circle>
          </div>
          <div class="o-background__group o-background__group--rust" key="rust" v-if="tabIndex === 6">
            <my-circle class="o-background__item o-background__item--1" :image-file="'circles/focus/innovation-1'" :variant="2"></my-circle>
            <my-circle class="o-background__item o-background__item--2" :image-file="'circles/focus/innovation-2'"></my-circle>
          </div>
          <div class="o-background__group o-background__group--green" key="green" v-if="tabIndex === 7">
            <my-circle class="o-background__item o-background__item--1" :image-file="'circles/focus/low-carbon-readiness-1'" :variant="2"></my-circle>
            <my-circle class="o-background__item o-background__item--2" :image-file="'circles/focus/low-carbon-readiness-2'"></my-circle>
          </div>
        </transition>
      </div>
    </div>

    <!-- Content -->
    <div class="o-section__container">
      <h2 class="o-section__title">Our focus areas</h2>

      <my-tabs class="o-tabs--wrapped" @tab-changed="setTabIndex">
        <my-tab class="c-focus c-focus--0" title="Safety" tab-color="purple">
          <my-focus-safety></my-focus-safety>
        </my-tab>
        <my-tab class="c-focus c-focus--1" title="Network reliability" tab-color="turq">
          <my-focus-network></my-focus-network>
        </my-tab>
        <my-tab class="c-focus c-focus--2" title="Customer satisfaction" tab-color="red">
          <my-focus-customer></my-focus-customer>
        </my-tab>
        <my-tab class="c-focus c-focus--3" title="Value for money" tab-color="smoke">
          <my-focus-value></my-focus-value>
        </my-tab>
        <my-tab class="c-focus c-focus--4" title="Communities &amp; environment" tab-color="orange">
          <my-focus-community></my-focus-community>
        </my-tab>
        <my-tab class="c-focus c-focus--5" title="Stakeholder engagement" tab-color="blue">
          <my-focus-stake></my-focus-stake>
        </my-tab>
        <my-tab class="c-focus c-focus--6" title="Innovation" tab-color="rust">
          <my-focus-inno></my-focus-inno>
        </my-tab>
        <my-tab class="c-focus c-focus--7" title="Low carbon readiness" tab-color="green">
          <my-focus-carbon></my-focus-carbon>
        </my-tab>
      </my-tabs>

    </div>
  </section>
</template>

<script>
import MyFocusSafety from '@/components/single/MyFocusSafety'
import MyFocusNetwork from '@/components/single/MyFocusNetwork'
import MyFocusCustomer from '@/components/single/MyFocusCustomer'
import MyFocusValue from '@/components/single/MyFocusValue'
import MyFocusCommunity from '@/components/single/MyFocusCommunity'
import MyFocusStake from '@/components/single/MyFocusStake'
import MyFocusInno from '@/components/single/MyFocusInno'
import MyFocusCarbon from '@/components/single/MyFocusCarbon'
import { MyTabs, MyTab } from '@/components/standard/my-tabs'
import { MySectionClass } from '@/directives/my-section-class'
import MyCircle from '@/components/standard/my-circle'
import mixins from '@/mixins'

export default {
  name: 'my-focus',
  components: {
    MyTabs,
    MyTab,
    MyCircle,
    MyFocusSafety,
    MyFocusNetwork,
    MyFocusCustomer,
    MyFocusValue,
    MyFocusCommunity,
    MyFocusStake,
    MyFocusInno,
    MyFocusCarbon
  },
  mixins: [mixins],
  directives: {
    MySectionClass
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// MyFocus.vue?01ed23ae